const ArticleBlockGallerySetup = () => {
  const components = document.querySelectorAll('[data-component-article-block-gallery]');

  components.forEach((component) => {
    const swiperContainer = component.querySelector('.swiper-container');
    let swiperInstance;

    const init = () => {
      const galleryId = swiperContainer.getAttribute('id');
      swiperInstance = new Swiper(`#${galleryId}`, {
        pagination: {
          el: `#swiper-pagination-${galleryId}`,
          clickable: true,
        },
        slidesPerView: window.innerWidth >= 768 ? 3 : 1,
        spaceBetween: 10,
        navigation: {
          nextEl: `.swiper-button-next-${galleryId}`,
          prevEl: `.swiper-button-prev-${galleryId}`,
        },
      });
    };

    if (swiperContainer) {
      init();
    }

    const handleWindowResize = () => {
      if (swiperInstance) {
        swiperInstance.destroy();
        init();
      }
    };

    window.addEventListener('resize', () => handleWindowResize());
  });
};
ArticleBlockGallerySetup();